// extracted by css-extract-rspack-plugin
export default {"cls1":"Upsell-cls1_jNu","cls2":"Upsell-cls2_OHr Upsell-cls1_jNu"};